// ============================================================================
// mesureEcritures.js — COMPTER avant de durcir
// ============================================================================
//
// Pour qu'une règle Firestore distingue un administrateur, il lui faut
// `request.auth`. Or `src/authGuard.js` ouvre la session Firebase AU MIEUX :
// un échec est consigné, la session est marquée périmée, et tout continue de
// fonctionner. Aucune écriture Firestore du dépôt n'attend
// `attendreAuthPrete()`. Poser la condition sans avoir mesuré refuserait donc
// les écritures d'une population inconnue — et SILENCIEUSEMENT, puisque
// FloatingChat, MaSemaineView et FavoriteStar avalent l'erreur : l'étoile
// reviendrait à sa place, le message d'accueil se réafficherait à vie, sans
// une alerte.
//
// On refait donc ici ce qui a réussi pour les Cloud Functions en septembre :
// mesurer d'abord, corriger les chemins, durcir ensuite. Même forme que la
// collection `authMesure`, un document par personne et par jour.
//
// TROIS ÉTATS, et la distinction est le cœur de la mesure :
//   • avecJeton     — une session Firebase existe : la règle passerait ;
//   • authNonPrete  — la restauration n'est pas finie : COURSE AU DÉMARRAGE,
//                     qui se corrige en posant attendreAuthPrete() ;
//   • sansJeton     — restauration finie, personne : session réellement
//                     absente, qui demande une reconnexion.
//
// La mesure est DÉCLARÉE par le client : c'est volontaire et suffisant. On ne
// cherche pas à piéger un attaquant, on veut savoir si NOTRE application
// écrit avec un jeton. Elle ne bloque jamais, n'échoue jamais bruyamment, et
// ne retarde aucune écriture : elle est lancée sans être attendue.
//
// À RETIRER une fois le verrou serveur posé (avec la collection et sa règle).
// ============================================================================

const CLE_DATE = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

/** Qui écrit, d'après la session Aramis (pas d'identité vérifiée ici : on mesure). */
function quiEcrit() {
  try {
    const s = localStorage.getItem("aramis_session") || sessionStorage.getItem("aramis_session");
    const o = s ? JSON.parse(s) : null;
    return (o && o.id) || "anonyme";
  } catch { return "anonyme"; }
}

/**
 * Consigne une écriture. `chemin` nomme le site appelant (« saveDelegate »,
 * « lastSeen »…) pour savoir QUOI corriger, pas seulement combien.
 * Fire-and-forget : on ne l'attend pas, on n'en propage rien.
 */
export function mesurerEcriture(chemin) {
  try {
    if (typeof window === "undefined") return;
    (async () => {
      try {
        const [{ auth, db }, garde, fs] = await Promise.all([
          import("./firebase"), import("./authGuard"), import("firebase/firestore"),
        ]);
        const prete = typeof garde.authPrete === "function" ? garde.authPrete() : true;
        const etat = auth && auth.currentUser ? "avecJeton" : (prete ? "sansJeton" : "authNonPrete");
        const userId = quiEcrit();
        const date = CLE_DATE();
        await fs.setDoc(fs.doc(db, "ecritureMesure", `${date}_${userId}`), {
          date, userId,
          [etat]: fs.increment(1),
          chemins: { [`${chemin}__${etat}`]: fs.increment(1) },
          dernierTs: Date.now(),
        }, { merge: true });
      } catch { /* une mesure ne fait jamais de bruit */ }
    })();
  } catch { /* idem */ }
}
